import NBox from './NBox'
import New from './new'
import Edit from './edit'
import List from './list'
import Matrix from './matrix'
import Report from './report'

export default NBox
export { New, List, Edit, Matrix, Report }
